import React, { PureComponent } from 'react'
import { FiPaperclip } from 'react-icons/fi'
import { Proposals, withContext, Link, Row, Grid, SpacedCol } from '@tools/wr-catalog-base'
import { submitProposal } from '@utils/proposals/submit-proposal'
import { trackPageView } from '@utils/tracking'
import DocTitle from '@components/DocTitle'

// const NAME_COLUMN = {
//   id: 'settings.docTemplateName',
//   label: 'Proposal Name',
//   // Fallback to `name` for older proposals that don't have that field
//   formatter: (value, row) => value || row.name,
// }

const POINTS_COLUMN = {
  id: 'settings.value',
  label: 'Points',
  textAlign: 'right',
}

const DOWNLOAD_COLUMN = {
  id: 'quote',
  label: 'Download',
  textAlign: 'center',
  formatter: (value, row) => {
    return !row.quote ? null : (
      <Link href={row.quote}>
        <FiPaperclip />
      </Link>
    )
  },
}
const getColumns = (defaultColumns) => {
  const columns = defaultColumns.slice()
  columns.shift()
  columns.forEach((col, i) => {
    if (col.id === 'settings.value') {
      columns[i] = POINTS_COLUMN
    }
    if (col.id === 'status') {
      columns[i] = DOWNLOAD_COLUMN
    }
  })
  return columns
}
class ProposalsView extends PureComponent {
  render() {
    const { context } = this.props

    const bodyEl = window.document.getElementsByTagName('body')[0]
    bodyEl.className = 'proposal-page'
    const loginBox = window.document.getElementsByClassName('loginBox')[0]
    if (loginBox) {
      loginBox.style.display = 'none'
    }

    if (!context.state.isLoggedIn) {
      return (
        <Grid>
          <Row>
            <SpacedCol xs={12}>
              <span>You must be logged in to view this page.</span>
              <span>
                You can log in <Link to="/login">here</Link>.
              </span>
            </SpacedCol>
          </Row>
        </Grid>
      )
    }

    return (
      <Grid>
        <Row>
          <SpacedCol xs={12}>
            <DocTitle title="Proposals" onChange={trackPageView} />
            <Proposals getColumns={getColumns} submitProposal={submitProposal} asQuotePdf />
          </SpacedCol>
        </Row>
      </Grid>
    )
  }
}

export default withContext(ProposalsView)
